import { db } from "@/config/firebase";
import {
    collection,
    addDoc,
    getDocs,
    serverTimestamp,
    updateDoc,
    doc,
    getDoc,
    deleteDoc,
    orderBy,
    query
    // setDoc
} from "firebase/firestore"

const collectionName = 'courses'

const state = {
    allCourses: []
}

const getters = {

}

const mutations = {
    doNothing: (state)=> state
}

const actions = {
    /**
     * @description Add Course
     * @param {Object} data 
     * @returns {Object} Object
    */
    async addCourse({ commit, rootState }, data) {
        data.createdAt = serverTimestamp()
        data.createdBy = rootState.authStore.currentUser.uid
        return new Promise((resolve, reject) => {
            addDoc(collection(db, collectionName), data).then(() => {
                commit('doNothing')
                resolve({
                    success: true,
                    message: 'Course Added Successfully'
                })
            })
                .catch(err => {
                    console.log(err);
                    reject(err)
                })
        })
    },

    /**
     * @description Get All Courses
     * @returns {Object} Object
    */
    async getCourses({ commit }) {
        let courses = []
        return new Promise((resolve, reject) => {
            getDocs(collection(db, collectionName)).then((querySnapshot => {
                querySnapshot.forEach(doc => {
                    courses.push({ ...doc.data(), ...{ docid: doc.id } })
                })
                commit('doNothing')
                resolve({
                    success: true,
                    data: courses
                })
            })).catch(err => {
                reject({
                    success: false,
                    error: err
                })
            })
        })
    },

    /**
     * @description Get All Courses By Order
     * @returns {Object} Object
    */
    async getCoursesByOrder({ commit }) {
        console.log('asdasd asd s');
        let courses = []
        let orderQuery = query(collection(db, collectionName), orderBy('createdAt', 'desc'));
        
        return new Promise((resolve, reject) => {
            getDocs(orderQuery).then((querySnapshot => {
                querySnapshot.forEach(async doc => {
                    courses.push({ ...doc.data(), ...{ docid: doc.id }})
                })
                commit('doNothing')
                console.log('asd', courses);
                resolve({
                    success: true,
                    data: courses
                })
            })).catch(err => {
                reject({
                    success: false,
                    error: err
                })
            })
        })
    },



    /**
     * @description Update Course
     * @param {Object} - Updated Data with Doc Id
     * @returns {Object} Object
    */
    async updateCourse({ commit, rootState }, data) {
        return new Promise((resolve, reject) => {
            let docRef = doc(db, collectionName, data.docid)
            data.updatedAt = serverTimestamp()
            data.updatedBy = rootState.authStore.currentUser.uid
            delete data.docid
            updateDoc(docRef, data).then(() => {
                commit('doNothing')
                resolve({
                    success: true,
                    message: 'Course Updated'
                })
            }).catch(err => {
                console.log('Err: ', err);
                reject({
                    success: false,
                    error: err
                })
            })
        })
    },

    /**
     * @description Get Course info by Id
     * @param {Number} - Doc Id
     * @returns {Object} Object
    */
    async getCourseById({ commit }, docid) {
        return new Promise((resolve, reject) => {
            let docRef = doc(db, collectionName, docid)
            getDoc(docRef).then(docSnap => {
                if (docSnap.exists()) {
                    commit('doNothing')
                    resolve({
                        success: true,
                        data: docSnap.data()
                    })
                } else {
                    resolve({
                        success: false,
                        message: 'No Data Found'
                    })
                }
            }).catch(err => {
                console.log('Err: ', err);
                reject({
                    success: false,
                    error: err
                })
            })
        })
    },

    /**
     * @description Remove Course by Id
     * @param {Number} - Doc Id
     * @returns {Object} Object
    */
    async removeCourse({ commit }, docid) {
        return new Promise((resolve, reject) => {
            deleteDoc(doc(db, collectionName, docid)).then(() => {
                commit('doNothing')
                resolve({
                    success: true,
                    message: 'Course Removed Successfully'
                })
            }).catch(err => {
                console.log('Err: ', err);
                reject({
                    success: false,
                    error: err
                })
            })

        })
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};